import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
	getCustomerGroupsTable,
	getProductGroupsTable,
	urls,
} from "./cgpgUtils";

const initialState = {
	isLoading: false,

	selectedView: "",

	countries: [],
	selectedCountry: "",
	selectedCountryID: "",

	groupStatusList: [],
	selectedGroupStatus: "",

	periods: [],
	selectedPeriod: "",

	productGroups: null,
	productGroupsTable: null,

	customerGroups: null,
	customerGroupsTable: null,

   selectedRows: [],

   rejectMultiModalOpen: false, 
   rejectSelectedComment: "",
};

export const getUserCountries = createAsyncThunk(
	"cgpgApproval/getUserCountries",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url = urls.userCountries + `userid=${data.userID}`;

			const response = await fetch(url, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("cgpgApproval/getUserCountries", error);
		}
	}
);

export const getGroupStatus = createAsyncThunk(
	"cgpgApproval/getGroupStatus",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url = urls.groupStatus;

			const response = await fetch(url, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("cgpgApproval/getGroupStatus", error);
		}
	}
);

export const getPeriods = createAsyncThunk(
	"cgpgApproval/getPeriods",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url = urls.periods;

			const response = await fetch(url, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("cgpgApproval/getPeriods", error);
		}
	}
);

export const getProductGroups = createAsyncThunk(
	"cgpgApproval/getProductGroups",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url = urls.productGroups;

			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
				body: JSON.stringify(obj),
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("cgpgApproval/getProductGroups", error);
		}
	}
);

export const getCustomerGroups = createAsyncThunk(
	"cgpgApproval/getCustomerGroups",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url = urls.customerGroups;

			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
				body: JSON.stringify(obj),
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("cgpgApproval/getCustomerGroups", error);
		}
	}
);

export const approveRejectMultiplePG = createAsyncThunk(
	"cgpgApproval/approveRejectMultiplePG",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url = urls.approveRejectMultiPG;

			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
				body: JSON.stringify(obj),
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("cgpgApproval/approveRejectMultiplePG", error);
		}
	}
);

export const approveRejectMultipleCG = createAsyncThunk(
	"cgpgApproval/approveRejectMultipleCG",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url = urls.approveRejectMultiCG;

			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
				body: JSON.stringify(obj),
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("cgpgApproval/approveRejectMultipleCG", error);
		}
	}
);

export const approveRejectPG = createAsyncThunk(
	"cgpgApproval/approveRejectPG",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url = urls.rejectApproveProductGroup;

			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
				body: JSON.stringify(obj),
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("cgpgApproval/approveRejectPG", error);
		}
	}
);

export const approveRejectCG = createAsyncThunk(
	"cgpgApproval/approveRejectCG",
	async (obj, thunkAPI) => {
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const token = data.token;
			const url = urls.rejectApproveCustomerGroup;

			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
					Accept: "application/json",
				},
				body: JSON.stringify(obj),
			});
			const jsonData = response.json();
			return jsonData;
		} catch (error) {
			console.error("cgpgApproval/approveRejectCG", error);
		}
	}
);

const cgpgSlice = createSlice({
	name: "cgpgApproval",
	initialState,
	reducers: {
		setState: {
			prepare(name, value) {
				return {
					payload: { name, value },
				};
			},
			reducer(state, action) {
				const { name, value } = action.payload;
				state[name] = value;
			},
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getUserCountries.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(getUserCountries.fulfilled, (state, action) => {
				state.countries = action.payload;
				state.isLoading = false;
			})
			.addCase(getUserCountries.rejected, (state, action) => {
				console.error(
					"cgpgApproval/getUserCountries",
					action.error.message
				);
				state.isLoading = false;
			})

			.addCase(getGroupStatus.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(getGroupStatus.fulfilled, (state, action) => {
				state.isLoading = false;
				state.groupStatusList = action.payload;
			})
			.addCase(getGroupStatus.rejected, (state, action) => {
				console.error("cgpgApproval/getGroupStatus", action.error.message);
				state.isLoading = false;
			})

			.addCase(getPeriods.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(getPeriods.fulfilled, (state, action) => {
				state.periods = action.payload;
				state.isLoading = false;
			})
			.addCase(getPeriods.rejected, (state, action) => {
				console.error("cgpgApproval/getPeriods", action.error.message);
				state.isLoading = false;
			})

			.addCase(getProductGroups.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(getProductGroups.fulfilled, (state, action) => {
				state.productGroups = action.payload;
				state.productGroupsTable = getProductGroupsTable(action.payload);
				state.isLoading = false;
			})
			.addCase(getProductGroups.rejected, (state, action) => {
				console.error(
					"cgpgApproval/getProductGroups",
					action.error.message
				);
				state.isLoading = false;
			})

			.addCase(getCustomerGroups.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(getCustomerGroups.fulfilled, (state, action) => {
				state.customerGroups = action.payload;
				state.customerGroupsTable = getCustomerGroupsTable(action.payload);
				state.isLoading = false;
			})
			.addCase(getCustomerGroups.rejected, (state, action) => {
				console.error(
					"cgpgApproval/getCustomerGroups",
					action.error.message
				);
				state.isLoading = false;
			})

			.addCase(approveRejectMultiplePG.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(approveRejectMultiplePG.fulfilled, (state, action) => {
				state.isLoading = false;
			})
			.addCase(approveRejectMultiplePG.rejected, (state, action) => {
				console.error(
					"cgpgApproval/approveRejectMultiplePG",
					action.error.message
				);
				state.isLoading = false;
			})

			.addCase(approveRejectMultipleCG.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(approveRejectMultipleCG.fulfilled, (state, action) => {
				state.isLoading = false;
			})
			.addCase(approveRejectMultipleCG.rejected, (state, action) => {
				console.error(
					"cgpgApproval/approveRejectMultipleCG",
					action.error.message
				);
				state.isLoading = false;
			})

			.addCase(approveRejectPG.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(approveRejectPG.fulfilled, (state, action) => {
				state.isLoading = false;
			})
			.addCase(approveRejectPG.rejected, (state, action) => {
				console.error(
					"cgpgApproval/approveRejectPG",
					action.error.message
				);
				state.isLoading = false;
			})

			.addCase(approveRejectCG.pending, (state, action) => {
				state.isLoading = true;
			})
			.addCase(approveRejectCG.fulfilled, (state, action) => {
				state.isLoading = false;
			})
			.addCase(approveRejectCG.rejected, (state, action) => {
				console.error(
					"cgpgApproval/approveRejectCG",
					action.error.message
				);
				state.isLoading = false;
			});
	},
});

export const { setState } = cgpgSlice.actions;
export default cgpgSlice.reducer;
